import { render, staticRenderFns } from "./multiple_choice_selector.vue.js?vue&type=template&id=0c50cb7b&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./multiple_choice_selector.vue?vue&type=template&id=0c50cb7b&vue3"
import script from "./multiple_choice_selector.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./multiple_choice_selector.vue?vue&type=script&lang=js&vue3"
export * from "./multiple_choice_selector.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./multiple_choice_selector.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports